import React, { useState } from 'react';
import { FiBox, FiLayers, FiUpload, FiX, FiCheck, FiChevronDown, FiUser, FiMail, FiPhone, FiMessageSquare, FiLink, FiCalendar, FiDollarSign } from 'react-icons/fi';
import './../styles/Career.css';
import { careerForm } from '../services/Service';
import { MdOutlineWatchLater } from 'react-icons/md';

const CareerForm = () => {
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    phone: '',
    linkedin_url: '',
    position: '',
    experience: '',
    skills: [],
    github_url: '',
    portfolio_url: '',
    currentSkill: '',
    resume: null,
    resume_name: '',
    cover_letter: '',
    availability: '',
    notice_period: '',
    currently_salary: '',
    salary_expectation: ''
  });
  const [submittedData, setSubmittedData] = useState(null);
  const [errors, setErrors] = useState({});
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const positionOptions = [
    'Frontend Developer',
    'Backend Developer',
    'Full Stack Developer',
    'DevOps Engineer',
    'Data Engineer',
    'Machine Learning Engineer',
    'QA Engineer',
    'Technical Lead',
    'UI/UX Designer',
    'Product Manager'
  ];

  const experienceOptions = [
    '0-1 years',
    '1-3 years',
    '3-5 years',
    '5-8 years',
    '8+ years'
  ];

  const availabilityOptions = [
    'Immediately',
    '1 month',
    '2 months',
    '3 months',
    'Custom date'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: ''
      }));
    }
  };

  const handleFileChange = (e) => {
    const resume = e.target.files[0];
    if (resume) {
      if (resume.size > 5 * 1024 * 1024) {
        setErrors(prev => ({ ...prev, resume: 'File size must be less than 5MB.' }));
      } else if (!['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(resume.type)) {
        setErrors(prev => ({ ...prev, resume: 'Only PDF or DOC files are allowed.' }));
      } else {
        setFormData(prev => ({
          ...prev,
          resume,
          resume_name: resume.name
        }));
        setErrors(prev => {
          const { resume, ...rest } = prev;
          return rest;
        });
      }
    }
  };

  const handleSkillAdd = () => {
    const skill = formData.currentSkill.trim().replace(/,$/, '');
    if (skill && !formData.skills.includes(skill)) {
      setFormData((prev) => ({
        ...prev,
        skills: [...prev.skills, skill],
        currentSkill: "",
      }));
      setErrors((prev) => {
        const { currentSkill, ...rest } = prev;
        return rest;
      });
    }
  };

  const handleSkillRemove = (skillToRemove) => {
    setFormData({
      ...formData,
      skills: formData.skills.filter(skill => skill !== skillToRemove)
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.full_name.trim()) {
      newErrors.full_name = 'Full name is required.';
    } else if (formData.full_name.length > 255) {
      newErrors.full_name = 'Your full name cannot be longer than 255 characters.';
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required.';
    } else if (formData.email.trim().length > 255) {
      newErrors.email = 'Your email cannot be longer than 255 characters.';
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email.trim())) {
      newErrors.email = 'Please enter a valid email.';
    }
    if (!formData.phone) {
      newErrors.phone = 'Phone number is required.';
    } else if (!/^\d{9,12}$/.test(formData.phone)) {
      newErrors.phone = 'Enter a valid phone number. It must be between 9 and 12 digits.';
    }
    if (!formData.position) newErrors.position = 'Please select a position.';
    if (!formData.experience) newErrors.experience = 'Please select a experience.';
    // if (formData.skills.length === 0) newErrors.currentSkill = 'Please add at least one skill.';
    if (formData.skills.length === 0 && !formData.currentSkill.trim()) {
      newErrors.currentSkill = 'Please add at least one skill.';
    }
    if (!formData.resume) {
      newErrors.resume = 'Please upload a resume.';
    } else if (formData.resume.size > 5 * 1024 * 1024) {
      newErrors.resume = 'File size must be less than 5MB.';
    } else if (!['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(formData.resume.type)) {
      newErrors.resume = 'Only PDF, DOC, or DOCX files are allowed.';
    }
    if (!formData.availability) newErrors.availability = 'Please select a availability.';
    if (!formData.notice_period) {
      newErrors.notice_period = 'Notice period is required.';
    } else if (!/^\d+$/.test(formData.notice_period)) {
      newErrors.notice_period = 'Notice period must be a number.';
    }
    if (!formData.currently_salary) {
      newErrors.currently_salary = 'Current salary is required.';
    } else if (!/^\d+$/.test(formData.currently_salary)) {
      newErrors.currently_salary = 'Current salary must be a number.';
    }
    if (!formData.salary_expectation) {
      newErrors.salary_expectation = 'Salary expectation is required.';
    } else if (!/^\d+$/.test(formData.salary_expectation)) {
      newErrors.salary_expectation = 'Salary expectation must be a number.';
    }
    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    setErrors({});
  // Handle skills validation
  if (formData.skills.length === 0) {
    if (!formData.currentSkill.trim()) {
      newErrors.currentSkill = "Please add at least one skill.";
    } else {
      newErrors.currentSkill = "You typed a skill but didn't add it.";
    }
  }

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    return;
  }
    if (Object.keys(newErrors).length === 0) {
      try {
        const currentFormDataForSubmission = { ...formData, skills: formData.skills };
        const result = await careerForm(currentFormDataForSubmission);
        if (result && result.data.message === 'Career successfully created.') {
          setIsSubmitted(true);
          window.scrollTo(0, 0);
          setSubmittedData(currentFormDataForSubmission);
          setFormData({
            full_name: '',
            email: '',
            phone: '',
            linkedin_url: '',
            position: '',
            experience: '',
            skills: [],
            github_url: '',
            portfolio_url: '',
            currentSkill: '',
            resume: null,
            resume_name: '',
            cover_letter: '',
            availability: 'immediately',
            notice_period: '',
            currently_salary: '',
            salary_expectation: ''
          });
        } else {
          setIsSubmitted(false);
          setErrors({ form: result?.message || result?.error || 'Form submission failed. Please try again later.' });
        }
      } catch (error) {
        setErrors({ form: 'An unexpected error occurred. Please try again later.' });
        setIsSubmitted(false);
      }
    } else {
      setErrors(newErrors);
    }
  };

  if (isSubmitted && submittedData) {
    return (
      <div className="career-form-container">
        <div className="success-card">
          <div className="success-card-body">
            <div className="success-card-left">
              <div className="success-icon">
                <FiCheck />
              </div>
              <h2>Application Submitted!</h2>
              <p className="success-message">
                Thank you for applying to {submittedData.position} position.
                We've received your application and will review it shortly.
              </p>
            </div>
            <div className="application-summary">
              <h3>Your Application Summary</h3>
              <div>
                <div className="summary-item">
                  <span className="summary-label">Name:</span>
                  <span className="summary-value">{submittedData.full_name}</span>
                </div>
                <div className="summary-item">
                  <span className="summary-label">Position:</span>
                  <span className="summary-value">{submittedData.position}</span>
                </div>
                <div className="summary-item">
                  <span className="summary-label">Experience:</span>
                  <span className="summary-value">{submittedData.experience}</span>
                </div>
                <div className="summary-item">
                  <span className="summary-label">Skills:</span>
                  <span className="summary-value">{submittedData.skills.join(', ')}</span>
                </div>
              </div>
            </div>
          </div>
          <button
            className="back-to-form-btn"
            onClick={() => {
              setIsSubmitted(false);
              setSubmittedData(null);
            }}
          >
            Submit Another Application
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="career-form-container">
      <div className="career-form-content">
        <div className="form-header">
          <h1>Technical Career Application</h1>
          <p className="subtitle">
            We're always looking for talented individuals to join our growing team.
            Fill out the form below to apply for open positions.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="career-form" noValidate>
          <div className="form-section">
            <h2>
              <span className="section-number">1</span>
              Personal Information
            </h2>

            <div className="form-row">
              <div className={`form-group required ${errors.full_name ? 'has-error' : ''}`}>
                <label htmlFor="full_name">Full Name</label>
                <div className="input-with-icon">
                  <FiUser className="input-icon" />
                  <input
                    type="text"
                    id="full_name"
                    name="full_name"
                    value={formData.full_name}
                    onChange={handleChange}
                    placeholder="Enter Full Name"
                    className={errors.full_name ? 'error' : ''}
                    autoComplete="off"
                    onBlur={() => {
                      if (!formData.full_name) {
                        setErrors((prev) => ({ ...prev, full_name: 'Full name is required.' }));
                      } else {
                        setErrors((prev) => {
                          const { full_name, ...rest } = prev;
                          return rest;
                        });
                      }
                    }}
                  // required
                  />
                </div>
                {errors.full_name && <span className="error-message">{errors.full_name}</span>}
              </div>

              <div className={`form-group required ${errors.email ? 'has-error' : ''}`}>
                <label htmlFor="email">Email</label>
                <div className="input-with-icon">
                  <FiMail className="input-icon" />
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter Email"
                    className={errors.email ? 'error' : ''}
                    autoComplete="off"
                    onBlur={() => {
                      if (!formData.email) {
                        setErrors((prev) => ({ ...prev, email: 'Email is required.' }));
                      } else {
                        setErrors((prev) => {
                          const { email, ...rest } = prev;
                          return rest;
                        });
                      }
                    }}
                  // required
                  />
                </div>
                {errors.email && <span className="error-message">{errors.email}</span>}
              </div>
            </div>

            <div className="form-row">
              <div className={`form-group required ${formData.phone || Object.keys(errors).includes('phone') ? (errors.phone ? 'has-error' : '') : ''}`}>
                <label htmlFor="phone">Phone Number</label>
                <div className="input-with-icon">
                  <FiPhone className="input-icon" />
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter Phone Number"
                    className={errors.phone ? 'error' : ''}
                    autoComplete="off"
                    onBlur={() => {
                      if (!formData.phone) {
                        setErrors((prev) => ({ ...prev, phone: 'Phone is required.' }));
                      } else {
                        setErrors((prev) => {
                          const { phone, ...rest } = prev;
                          return rest;
                        });
                      }
                    }}
                  // required
                  />
                </div>
                {errors.phone && <span className="error-message">{errors.phone}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="linkedin">LinkedIn Profile</label>
                <div className="input-with-icon">
                  <FiLink className="input-icon" />
                  <input
                    type="url"
                    id="linkedin_url"
                    name="linkedin_url"
                    value={formData.linkedin_url}
                    onChange={handleChange}
                    placeholder="Enter linkedin URL"
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2>
              <span className="section-number">2</span>
              Position Details
            </h2>

            <div className="form-row">
              <div className={`form-group required ${errors.position ? 'has-error' : ''}`}>
                <label htmlFor="position">Position Applying For</label>
                <div className="custom-select">
                  <FiBox className="input-icon" />
                  <select
                    id="position"
                    name="position"
                    value={formData.position}
                    onChange={handleChange}
                    className={errors.position ? 'error' : ''}
                    onBlur={() => {
                      if (!formData.position) {
                        setErrors((prev) => ({ ...prev, position: 'Please select a position.' }));
                      } else {
                        setErrors((prev) => {
                          const { position, ...rest } = prev;
                          return rest;
                        });
                      }
                    }}
                  // required
                  >
                    <option value="">Select a position</option>
                    {positionOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                  <FiChevronDown className="select-arrow" />
                </div>
                {errors.position && <span className="error-message">{errors.position}</span>}
              </div>

              <div className={`form-group required ${errors.experience ? 'has-error' : ''}`}>
                <label htmlFor="experience">Years of Experience</label>
                <div className="custom-select">
                  <FiLayers className="input-icon" />
                  <select
                    id="experience"
                    name="experience"
                    value={formData.experience}
                    onChange={handleChange}
                    className={errors.experience ? 'error' : ''}
                    onBlur={() => {
                      if (!formData.experience) {
                        setErrors((prev) => ({ ...prev, experience: 'Please select a experience.' }));
                      } else {
                        setErrors((prev) => {
                          const { experience, ...rest } = prev;
                          return rest;
                        });
                      }
                    }}
                  // required
                  >
                    <option value="">Select experience</option>
                    {experienceOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                  <FiChevronDown className="select-arrow" />
                </div>
                {errors.experience && <span className="error-message">{errors.experience}</span>}
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2>
              <span className="section-number">3</span>
              Skills & Qualifications
            </h2>

            <div className={`form-group required ${errors.currentSkill ? 'has-error' : ''}`}>
              <label>Your Technical Skills</label>
              <div className="skills-input-container">
                <input
                  type="text"
                  value={formData.currentSkill}
                  onChange={(e) => setFormData({ ...formData, currentSkill: e.target.value })}
                  placeholder="e.g. JavaScript, Python, AWS"
                  onKeyPress={(e) => e.key === 'Enter' && handleSkillAdd()}
                  className={errors.currentSkill ? 'error' : ''}
                  autoComplete="off"
                    onKeyDown={(e) => {
                      if ((e.key === 'Enter' || e.key === ',') && formData.currentSkill.trim()) {
                        e.preventDefault(); // Prevent form submission or comma input
                        handleSkillAdd();
                      }
                    }}
                  onBlur={() => {
                    const trimmedSkill = formData.currentSkill.trim();
                    if (trimmedSkill && formData.skills.length === 0) {
                      // Add skill automatically on blur if it's the first one
                      handleSkillAdd();
                    }
                    if (formData.skills.length === 0 && !formData.currentSkill.trim()) {
                      setErrors((prev) => ({ ...prev, currentSkill: 'Please add at least one skill.' }));
                    } else {
                      setErrors((prev) => {
                        const { currentSkill, ...rest } = prev;
                        return rest;
                      });
                    }
                  }}
                />
                {/* <button
                  type="button"
                  onClick={handleSkillAdd}
                  className="add-skill-btn"
                  disabled={!formData.currentSkill.trim()}
                >
                  Add
                </button> */}
              </div>
              {errors.currentSkill && <span className="error-message">{errors.currentSkill}</span>}

              {formData.skills.length > 0 && (
                <div className="skills-tags">
                  {formData.skills.map(skill => (
                    <span key={skill} className="skill-tag">
                      {skill}
                      <button
                        type="button"
                        onClick={() => handleSkillRemove(skill)}
                        className="remove-skill-btn"
                      >
                        <FiX />
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="github">GitHub Profile</label>
              <div className="input-with-icon">
                <FiLink className="input-icon" />
                <input
                  type="url"
                  id="github_url"
                  name="github_url"
                  value={formData.github_url}
                  onChange={handleChange}
                  placeholder="Enter github URL"
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="portfolio">Portfolio Website</label>
              <div className="input-with-icon">
                <FiLink className="input-icon" />
                <input
                  type="url"
                  id="portfolio_url"
                  name="portfolio_url"
                  value={formData.portfolio_url}
                  onChange={handleChange}
                  placeholder="Enter Portfolio URL"
                  autoComplete="off"
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2>
              <span className="section-number">4</span>
              Documents
            </h2>

            <div className="form-row">
              <div className={`form-group required ${errors.resume ? 'has-error' : ''}`}>
                <label>Upload Resume</label>
                <div className={`file-upload ${errors.resume ? 'error' : ''}`}>
                  <label htmlFor="resume" className="file-upload-label">
                    <FiUpload className="upload-icon" />
                    <span>
                      {formData.resume_name || ' Choose file (PDF, DOC)'}
                    </span>
                    <input
                      type="file"
                      id="resume"
                      name="resume"
                      onChange={handleFileChange}
                      accept=".pdf,.doc,.docx"
                      className={errors.resume ? 'error' : ''}
                      onBlur={() => {
                        if (!formData.resume) {
                          setErrors((prev) => ({ ...prev, resume: 'Please upload resume.' }));
                        } else {
                          setErrors((prev) => {
                            const { resume, ...rest } = prev;
                            return rest;
                          });
                        }
                      }}
                    // required
                    />
                  </label>
                </div>
                {errors.resume && <span className="error-message">{errors.resume}</span>}
                <p className="file-hint">Max file size: 5MB</p>
              </div>

              <div className="form-group">
                <label htmlFor="coverLetter">Cover Letter</label>
                <div className="input-with-icon">
                  <FiMessageSquare className="input-icon" />
                  <textarea
                    id="cover_letter"
                    name="cover_letter"
                    value={formData.cover_letter}
                    onChange={handleChange}
                    rows="4"
                    placeholder="Tell us why you're a great fit for this position..."
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2>
              <span className="section-number">5</span>
              Availability & Expectations
            </h2>

            <div className="form-row">
              <div className={`form-group required ${errors.availability ? 'has-error' : ''}`}>
                <label htmlFor="availability">Available From</label>
                <div className="input-with-icon">
                  <FiCalendar className="input-icon" />
                  <div className="custom-select">
                    <select
                      id="availability"
                      name="availability"
                      value={formData.availability}
                      onChange={handleChange}
                      className={errors.availability ? 'error' : ''}
                      onBlur={() => {
                        if (!formData.availability) {
                          setErrors((prev) => ({ ...prev, availability: 'Please select a availability.' }));
                        } else {
                          setErrors((prev) => {
                            const { availability, ...rest } = prev;
                            return rest;
                          });
                        }
                      }}
                    // required
                    >
                      <option value="">Select a availability</option>
                      {availabilityOptions.map(option => (
                        <option key={option} value={option.toLowerCase().replace(' ', '-')}>
                          {option}
                        </option>
                      ))}
                    </select>
                    <FiChevronDown className="select-arrow" />
                  </div>
                </div>
                {errors.availability && <span className="error-message">{errors.availability}</span>}
              </div>

              <div className={`form-group required ${errors.notice_period ? 'has-error' : ''}`}>
                <label htmlFor="noticePeriod">Notice Period</label>
                <div className="input-with-icon">
                  <MdOutlineWatchLater className="input-icon" />
                  <input
                    type="text"
                    id="notice_period"
                    name="notice_period"
                    value={formData.notice_period}
                    onChange={handleChange}
                    placeholder="Enter Notice Period"
                    className={errors.notice_period ? 'error' : ''}
                    autoComplete="off"
                    onBlur={() => {
                      if (!formData.notice_period) {
                        setErrors((prev) => ({ ...prev, notice_period: 'Notice period is required.' }));
                      } else {
                        setErrors((prev) => {
                          const { notice_period, ...rest } = prev;
                          return rest;
                        });
                      }
                    }}
                  // required
                  />
                </div>
                {errors.notice_period && <span className="error-message">{errors.notice_period}</span>}
              </div>
            </div>
            <div className="form-row">
              <div className={`form-group required ${errors.currently_salary ? 'has-error' : ''}`}>
                <label htmlFor="currently_salary">Current Salary</label>
                <div className="input-with-icon">
                  <FiDollarSign className="input-icon" />
                  <input
                    type="text"
                    id="currently_salary"
                    name="currently_salary"
                    value={formData.currently_salary}
                    onChange={handleChange}
                    placeholder="Enter Current Salary"
                    className={errors.currently_salary ? 'error' : ''}
                    autoComplete="off"
                    onBlur={() => {
                      if (!formData.currently_salary) {
                        setErrors((prev) => ({ ...prev, currently_salary: 'Current salary is required.' }));
                      } else {
                        setErrors((prev) => {
                          const { currently_salary, ...rest } = prev;
                          return rest;
                        });
                      }
                    }}
                  // required
                  />
                </div>
                {errors.currently_salary && <span className="error-message">{errors.currently_salary}</span>}
              </div>

              <div className={`form-group required ${errors.salary_expectation ? 'has-error' : ''}`}>
                <label htmlFor="salaryExpectation">Expected Salary</label>
                <div className="input-with-icon">
                  <FiDollarSign className="input-icon" />
                  <input
                    type="text"
                    id="salary_expectation"
                    name="salary_expectation"
                    value={formData.salary_expectation}
                    onChange={handleChange}
                    placeholder="Enter Expected Salary"
                    className={errors.salary_expectation ? 'error' : ''}
                    autoComplete="off"
                    onBlur={() => {
                      if (!formData.salary_expectation) {
                        setErrors((prev) => ({ ...prev, salary_expectation: 'Expected Salary is required.' }));
                      } else {
                        setErrors((prev) => {
                          const { salary_expectation, ...rest } = prev;
                          return rest;
                        });
                      }
                    }}
                  // required
                  />
                </div>
                {errors.salary_expectation && <span className="error-message">{errors.salary_expectation}</span>}
              </div>
            </div>
          </div>

          <div className="form-footer">
            <button
              type="submit"
              className="submit-btn"
            // disabled={isSubmitting}
            >
              {/* {isSubmitting ? (
                <>
                  <span className="spinner"></span>
                  Processing...
                </>
              ) : ( */}
              Submit
              {/* )} */}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CareerForm;